import AppointmentsTab from "../../../../patient/details/appointments/AppointmentsTab";

export default function AppointmentsDrawerTab({ classes, goToCaseTabHandler, column = 5, inWorkQ }) {
    return (
        <div className={`${classes.block} ${classes[`block_${column}`]}`}>
            <AppointmentsTab inWorkQ={inWorkQ} subscribeRemoteList={false} />
        </div>
    )
}
